import { render, staticRenderFns } from "./TimesCardPriceForm.vue?vue&type=template&id=1963b4e6&scoped=true&"
import script from "./TimesCardPriceForm.vue?vue&type=script&lang=js&"
export * from "./TimesCardPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963b4e6",
  null
  
)

export default component.exports